export const authPaths = {
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  REGISTER: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  EMAIL_VERIFICATION: "/email-verification",
  RETRIEVE: "/retrieve",
  APPLY: "/application",
}

export const supervisor = {
  DASHBOARD: "/map-visualization",
  PREDICTION: "/Prediction",
  EVENTS: "/satellite-events",
  SATELITE: "/satellite",
  NOTIFICATIONS: "/notifications",
  TASKS: "/tasks",
  SETTINGS: "/settings",
  PROFILE: "/profile",
  LOCATION: "/location",
}

export const Admin = {
  DASHBOARD: "/map-visualization",
  PREDICTION: "/Prediction",
  EVENTS: "/satellite-events",
  SATELITE: "/satellite",
  NOTIFICATIONS: "/notifications",
  MANAGEMENT: "/User-Management",
  SETTINGS: "/settings",
  PROFILE: "/profile",
  LOCATION: "/location",
}
